import React, { useEffect, useState } from "react";
// nodejs library to set properties for components
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import styles from "assets/jss/material-kit-react/components/resumeStyle.js";
import classNames from "classnames";
import {Helmet} from 'react-helmet'



const useStyles = makeStyles(styles);

export default function ScienceCommitteeDetailsTemplate(props) {
  const { data } = props

  const classes = useStyles();
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRoundedCircle,
    classes.imgCube,
    classes.imgProfile
  );


  const css = `
  .showInPrint{
    display: none;
  }
  .hiddenInPrint{
    display: block;
  }
  @media print {
    body * {
      visibility: hidden;
    }
    body {
      display: table;
      table-layout: fixed;
      padding-top: 2.5cm;
      padding-bottom: 2.5cm;
      height: auto;
  }
    .showInPrint{
    display: block;
    }
    .hiddenInPrint{
      display: none;
    }
    #section-to-print, #section-to-print *,.section-to-print, .section-to-print * {
      visibility: visible;
    }
  
    #section-to-print,.section-to-print {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
`
  return (
    <form noValidate autoComplete="off">
      <style >
        {css}
      </style>
      <Helmet>
    <title>{data?.name}</title>
    <meta name="description" content={data?.description} />
    <meta name="keywords" content={data?.skills} />
    <meta name="image" content={data?.picture} />
  </Helmet>
      <GridContainer className={classes.root} justify="center">
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.div}>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.center + " " + classes.fastAccess}>
                      <img src={data?.picture} alt={data?.name} className={imageClasses} />
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.center + " " + classes.topMargin}>
                      <Typography variant="h6" gutterBottom component="div">
                      {data?.name}
                      </Typography>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.center + " " + classes.topMargin}>
                      <Typography variant="overline" display="block" gutterBottom>
                        {data?.description && data?.description.split('\n').map(str => <p>{str.length > 1 ? str : <br />}</p>)}

                      </Typography>
                    </div>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={12}>
                    <Divider />

                    <div className={classes.left + " " + classes.fastAccess}>
                      <div className={classes.together} >
                        <Typography variant="h6" gutterBottom component="div">
                          تحصیلات
                        </Typography>
                        <div class='box'>
                          <ul>
                            {data?.educations.map((education, i) => {
                              return (<li>
                                <Typography variant="body2" gutterBottom>
                                  {education}
                                </Typography>
                              </li>)
                            })}

                          </ul>
                        </div>
                      </div>
                      <div className={classes.together} >
                        <Typography variant="h6" gutterBottom component="div">
                          سوابق شغلی
                        </Typography>
                        <div class='box'>
                          <ul>
                            {data?.jobs.map((job, i) => {
                              return (
                                <li> <Typography variant="body2" gutterBottom>
                                  {job}
                                </Typography></li>)
                            })}
                          </ul>

                        </div>
                      </div>
                      <div className={classes.together} >
                        <Typography variant="h6" gutterBottom component="div">
                          مهارت‌ها
                        </Typography>
                        <div class='box'>
                          <ul>
                            {data?.skills.map((skill, i) => {
                              return (<li> <Typography variant="body2" gutterBottom>
                                {skill}
                              </Typography></li>)
                            })}
                          </ul>
                        </div>
                      </div>
                      <div className={classes.together} >
                        <Typography variant="h6" gutterBottom component="div">
                          افتخارات
                        </Typography>
                        <div class='box'>
                          <ul>
                            {data?.honors.map((honor, i) => {
                              return (<li> <Typography variant="body2" gutterBottom>
                                {honor}
                              </Typography></li>)
                            })}
                          </ul>
                        </div>
                      </div>
                      <div className={classes.together} id="projects">
                        <Typography variant="h6" gutterBottom component="div">
                          پروژه‌ها
                        </Typography>
                        <div class='box'>
                          <ul>
                            {data?.projects.map((project, i) => {
                              var p = project.split('[&]')
                              var pro = {};
                              pro.name = p[0]
                              pro.link = (p.length > 1) ? p[1] : ""
                              return (pro?.link) ? (<li>
                                <Typography variant="body2" gutterBottom>
                                  <a className={classes.ancher} size="small" href={pro.link} variant="text">{pro?.name}</a>
                                </Typography>
                              </li>) :
                                (<li>
                                  <Typography variant="body2" gutterBottom>
                                    <a className={classes.ancher} size="small" variant="text">{pro?.name}</a>
                                  </Typography>
                                </li>)

                            })}
                          </ul>
                        </div>
                      </div>

                    </div>
                  </GridItem>
                </GridContainer>


              </div>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </form>
  );
}